import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import FormContext from './FormContext.js';

const withForm = function withForm(WrappedComponent) {
    const FormWrapper = forwardRef((props, ref) => (jsx(FormContext.Consumer, { children: ({ addToForm, isValid, onFormChange, removeFromForm, resetta, stato, validare, }) => (jsx(WrappedComponent, Object.assign({ addToForm: addToForm, isValid: isValid, onFormChange: onFormChange, removeFromForm: removeFromForm, resetta: resetta, stato: stato, validare: validare, ref: ref }, props))) })));
    const getDisplayName = (WComponent) => WComponent.displayName || WComponent.name || 'Component';
    FormWrapper.displayName = `withForm(${getDisplayName(FormWrapper)})`;
    return FormWrapper;
};

export { withForm as default };
